const INTRO_TIP_RATIO = 0.06;
const OUTRO_DURATION = 0.56;
const OUTRO_END_GAP = 0.035;
const OUTRO_TAIL_TARGET = 1;
const OUTRO_TIP_TARGET = 1 + INTRO_TIP_RATIO;
const EPSILON = 0.0001;
const STEADY_TIP_TARGET = 1 - OUTRO_END_GAP;
const PLAYBACK_TIP_SPAN = STEADY_TIP_TARGET - INTRO_TIP_RATIO;
const OUTRO_TIP_SPAN = OUTRO_TIP_TARGET - STEADY_TIP_TARGET;

type ProgressRingRatios = { tailRatio: number; tipRatio: number };

function easeInOutCubic(t: number) {
  return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
}

function easeOutCubic(t: number) {
  return 1 - (1 - t) ** 3;
}

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function getProgressRingRatios({
  currentTime,
  duration,
}: {
  currentTime: number;
  duration: number;
}): ProgressRingRatios {
  if (duration <= EPSILON) {
    return { tailRatio: 0, tipRatio: INTRO_TIP_RATIO };
  }

  const adjustedOutroDuration = Math.min(OUTRO_DURATION, duration * 0.22);
  const outroStartTime = duration - adjustedOutroDuration;

  const playbackProgress = clamp(currentTime / outroStartTime, 0, 1);
  const playbackTipRatio = PLAYBACK_TIP_SPAN * playbackProgress;

  let outroTailRatio = 0;
  let outroTipRatio = 0;

  if (currentTime > outroStartTime) {
    const outroProgress = clamp((currentTime - outroStartTime) / adjustedOutroDuration, 0, 1);
    outroTailRatio = OUTRO_TAIL_TARGET * easeInOutCubic(outroProgress);
    outroTipRatio = OUTRO_TIP_SPAN * easeOutCubic(outroProgress);
  }

  return {
    tailRatio: outroTailRatio,
    tipRatio: INTRO_TIP_RATIO + playbackTipRatio + outroTipRatio,
  };
}

export type { ProgressRingRatios };
